import { Dayjs } from 'dayjs';
import { Job } from '@core/generated/gql-types';
import { usePriorWeekData } from '@/modules/dashboard/hooks/usePriorWeekData';
import FilledJobs from './summaryCards/FilledJobs';
import FillRate from './summaryCards/FillRate';
import ActiveWorkers from './summaryCards/ActiveWorkers';
import HoursCompleted from './summaryCards/HoursCompleted';

interface JobsSummaryProps {
  jobs: Job[];
  filledJobs: Job[];
  unfilledJobs: Job[];
  timeframeStartDate: Dayjs;
  timeframeEndDate: Dayjs;
}

const JobsSummary = ({
  jobs,
  filledJobs,
  unfilledJobs,
  timeframeStartDate,
  timeframeEndDate,
}: JobsSummaryProps) => {
  const { priorWeekFilledJobs, comparisonLabel } = usePriorWeekData(
    jobs,
    timeframeStartDate,
    timeframeEndDate,
  );

  return (
    <div className="@container mb-4">
      <div className="grid grid-cols-1 gap-4 @3xl:grid-cols-2 @4xl:grid-cols-4">
        <FilledJobs filledJobs={filledJobs} unfilledJobs={unfilledJobs} />
        <FillRate
          filledJobs={filledJobs}
          unfilledJobs={unfilledJobs}
          priorWeekFilledJobs={priorWeekFilledJobs}
          comparisonLabel={comparisonLabel}
        />
        <ActiveWorkers
          filledJobs={filledJobs}
          priorWeekFilledJobs={priorWeekFilledJobs}
          comparisonLabel={comparisonLabel}
        />
        <HoursCompleted
          filledJobs={filledJobs}
          priorWeekFilledJobs={priorWeekFilledJobs}
          comparisonLabel={comparisonLabel}
        />
      </div>
    </div>
  );
};

export default JobsSummary;
